import { Eye, Target } from "lucide-react";
import "./index.css";

export default function VisionMission() {
  return (
    <div className="vm-page">
      <div className="vm-inner">
        <div className="vm-eyebrow"><span className="vm-dash" />WHO WE ARE<span className="vm-dash" /></div>
        <h1 className="vm-title">OUR VISION <span>&amp;</span> MISSION</h1>
        <span className="vm-title-underline" />
        <p className="vm-desc">
          At the core of our company lies a strong vision and mission that guide
          our every action and decision.
        </p>

        <div className="vm-grid">
          <div className="vm-card">
            <div className="vm-ic"><Eye size={30} /></div>
            <h2 className="vm-card-title">Our Vision</h2>
            <span className="vm-card-underline" />
            <p className="vm-card-text">
              To establish ourselves as one of the foremost and most trusted
              brokerage firms, catering to retail, institutional, and
              international investors seeking to invest in Pakistan’s stock
              markets. We are committed to providing seamless, transparent, and
              technology-driven trading solutions that empower our clients with
              expert insights, efficient execution, and a secure investment
              environment. Through innovation, integrity, and excellence in
              financial services, we aim to foster long-term relationships and
              contribute to the growth and development of Pakistan’s capital
              market.
            </p>
          </div>

          <div className="vm-card">
            <div className="vm-ic"><Target size={30} /></div>
            <h2 className="vm-card-title">Our Mission</h2>
            <span className="vm-card-underline" />
            <p className="vm-card-text">
              To provide attractive low cost brokerage services to our valued
              clients, provide our clients with state of the art trading
              facilities and up-to-date capital market research and offer them
              best execution of their investment plan. Our professional
              trainings team will educate our clients about the investment
              instruments and how to discover new horizons of investments to
              place their fortune. Our financial advisors will offer step by
              step guidance to our valued clients to achieve their goals and our
              compliance and settlement team will keep track of the investments
              to make sure that every aspect of the investments meets the
              regulatory requirement of the capital markets.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
